module.exports = __webpack_public_path__ + "img/Ppogo.a0ed0b30.jpg";